import React, {useContext, useEffect, useState} from "react";
import { Observable, map, debounceTime, distinctUntilChanged } from "rxjs";
import FormBuilder from "../../../class/tool/FormBuilder";
import FilterContext from "../../../context/FilterContext";
import "../../../css/page/Filters.css";
import "../../../css/form/Form.css";
import AuthController from "../../../stories/_auth/Auth/AuthController";
import StoreController from "../../../stories/_client/Stores/StoreController";

const Filters = props => {
    const { page } = props;
    const { filters, setFilters } = useContext(FilterContext);
    const [ filtersModel, setFiltersModel ] = useState([]);
    const [ versions, setVersions ] = useState([{
		text: "all",
		id: 0
	}]);
    const [ dictVersions, setDictVersions ] = useState({
		"all": "Toutes versions"
	});

    const initValues= () => {
        switch (page) {
            case "dashboard":
                setFilters(prev => ({
                    ...prev
                }))
                break
            case "client":
                setFilters(prev => ({
                    ...prev,
                    type: "all",
                    state: "all",
                    version: "all",
                    search: ""
                }));

				getFragmentation();

                break;
            case "developmentRequest":
                setFilters(prev => ({
                    ...prev,
                    state: "all",
                    search: ""
                }));

                break;
            case "product":
                setFilters(prev => ({
                    ...prev,
                    category: "all",
                    search: ""
                }))
                break
            default: break
        }
    }
    const listFilters = () => {
        switch (page) {
            case "dashboard":
                setFiltersModel([])
                break
            case "client":
                setFiltersModel([
                    {
                        attribute: "type",
                        inputType: "tab",
                        returnType: "string",
                        title: "",
                        list: [
                            {
                                text: "all",
                                id: 0
                            },
                            {
                                text: "client",
                                id: 1
                            },
                            {
                                text: "prospect",
                                id: 2
                            }
                        ],
                        dictionary: {
                            "all": "Tous",
                            "prospect": "Prospect",
                            "client": "Client"
                        },
                        classnameInput: "borderRadiusMore"
                    },
                    {
                        attribute: "state",
                        inputType: "select",
                        returnType: "string",
                        title: "État",
                        list: [
                            {
                                text: "all",
                                id: 0
                            },
                            {
                                text: "active",
                                id: 1
                            },
                            {
                                text: "inactive",
                                id: 2
                            },
                            {
                                text: "deleted",
                                id: 3
                            }
                        ],
                        dictionary: {
                            "all": "Tous les états",
                            "active": "Actif",
                            "inactive": "Inactif",
                            "deleted": "Supprimé"
                        },
                        classnameInput: "borderRadiusMore size1"
                    },
                    {
                        attribute: "version",
                        inputType: "select",
                        returnType: "string",
                        title: "Version",
                        list: versions,
                        dictionary: dictVersions,
                        classnameInput: "borderRadiusMore size1"
                    }
                ])

                break;
            case "developmentRequest":
                setFiltersModel([
                    {
                        attribute: "state",
                        inputType: "select",
                        returnType: "string",
                        title: "État",
                        list: [
                            {
                                text: "ALL",
                                id: 0
                            },
                            {
                                text: "WAITING",
                                id: 1
                            },
                            {
                                text: "ACCEPTED",
                                id: 2
                            },
                            {
                                text: "REJECTED",
                                id: 3
                            }
                        ],
                        dictionary: {
                            "ALL": "Tous les états",
                            "WAITING": "En attente",
                            "ACCEPTED": "Acceptée",
                            "REJECTED": "Rejetée"
                        },
                        classnameInput: "borderRadiusMore size1"
                    }
                ])

                break;
            case "product":
                setFiltersModel([
                    {
                        attribute: "state",
                        inputType: "select",
                        title: "Catégorie",
                        list: [
                            {
                                text: "all",
                                id: 0
                            }
                        ],
                        dictionary: {
                            "all": "Toutes les catégories"
                        },
                        classnameInput: "size3"
                    },
                    {
                        attribute: "search",
                        inputType: "text",
                        returnType: "string",
                        icon: "search",
                        placeholder: "Rechercher",
                        value: "",
                        classnameInput: "size2"
                    }
                ]);

                break;
            default: break;
        }
    }
	const updateFilterVersion = () => {
		if (page !== "client" || filtersModel.length === 0) return;

		let tmpFiltersModel = filtersModel.slice();
		const index = tmpFiltersModel.findIndex(_ => _.attribute === "version" && _.inputType === "select");
		if (index < 0) return;

		tmpFiltersModel[index].list = versions;
		tmpFiltersModel[index].dictionary = dictVersions;

		setFiltersModel(tmpFiltersModel);
	}
    const buildFilter = (filter, index) => {
        return <div key={index} className="filter">
            {
                FormBuilder.buildInputByType(filter, filters, [], change)
            }
        </div>
    }
    const change = (attribute, returnType, val, strict = false) => {
        let rows = filtersModel;
        let index;

        switch (returnType) {
            default:
                let value = FormBuilder.buildVal(returnType, val);
                let filtered = rows.filter(row => row.attribute === attribute && row.inputType === "select" && row.returnType === "int");
                index = value;

                if (!strict && filtered.length > 0 && filtered[0].list.length > 0) {
                    value = parseInt(filtered[0].list[index].id);

                    if (filtered[0].list[index].type !== undefined && filters[attribute.replace("_id", "_type")] !== undefined) {
                        setFilters(prev => ({
                            ...prev,
                            [attribute]: value,
                            [attribute.replace("_id", "_type")]: filtered[0].list[index].type
                        }));
                    }
                    else {
                        setFilters(prev => ({
                            ...prev,
                            [attribute]: value
                        }));
                    }
                }
                else {
                    filtered = rows.filter(row => row.attribute === attribute && row.inputType === "select" && row.returnType === "string")

                    if (filtered.length > 0) {
                        if (filtered[0].list.filter(_ => _.value === value && _.id !== undefined && _.id === null).length > 0)
                            value = null
                    }

                    setFilters(prev => ({
                            ...prev,
                            [attribute]: value
                        }))
                }

                break;
        }
    }
    const initSearching = () => {
		if (filtersModel.length === 0) return;

        const input = document.querySelector("#searchBarInput");
		if (input === null) return;

        const inputSearch$ = new Observable(observer => {
            input.addEventListener("input", (event) => {
                observer.next(event);
            })
        });
        const inputed$ = inputSearch$.pipe(
            map((event) => event.target.value),
            debounceTime(500),
            distinctUntilChanged()
        );

        inputed$.subscribe(value => {
            changeInput(value);
        });
    }
    const changeInput = value => {
		change("search", "string", value);
    }
	const getFragmentation = () => {
		if (!AuthController.hasRules("admin")) return;

		const controller = new StoreController();
		controller._callback = returnGetFragmentation;
		controller.fragmentation();
	}
    const returnGetFragmentation = (result, error, status) => {
        switch (status) {
            case 200:
				let tVersions = [{
					text: "all",
					id: 0
				}];
				let tDictVersions = {
					"all": "Toutes versions"
				};

				for (let i in result.data) {
					tVersions.push({
						text: result.data[i].version,
						id: i+1
					});
					tDictVersions[result.data[i].version] = result.data[i].version;
				}

				setVersions(tVersions);
				setDictVersions(tDictVersions);

                break;
            default:
                break;
        }
    }

    useEffect(() => {
        initValues();
    }, [page]);
    useEffect(() => {
        if (Object.keys(filters).length > 0)
            listFilters();
    }, [filters]);
    useEffect(() => {
        updateFilterVersion();
    }, [versions, dictVersions]);
	useEffect(() => {
		initSearching();
	}, [filtersModel]);

    return (
		filtersModel.length > 0
		&& <div id={"wrapFilters"} className={"wrapFilters"}>
            <div className={ "filters " + page }>
                {
                    filtersModel.map((filter, index) => buildFilter(filter, index))
                }
				<div className="filter">
					<div className={ "textInput borderRadiusMore border size1"}>
						<input type={"text"} id={"searchBarInput"} name={"input"} placeholder={"Rechercher"} />
					</div>
				</div>
                <div className="clearing" />
            </div>
        </div>
    )
}

export default Filters;
